import { getOffers } from "api/offers";
import NextPopup from "components/NextPopup";
import Template1 from "components/Template1";
import Template4 from "components/Template4";
import Template6 from "components/Template6";
import useImko from "hooks/useImko";
import useInterval from "hooks/useInterval";
import { useContext, useMemo } from "react";
import { useCallback, useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
// import logoGray from "logo_gray.svg";
import { IOffer } from "types/IOffer";
import Template2 from "components/Template2";
import linq from "linq";
import {
  MIN_SWIPER_CHANGES,
  SWIPER_DELAY,
  SWIPER_DURATION,
} from "helpers/const";
import { WebSocketContext } from "@bit/arey.instore-utils-react.websocket";
import { motion, useAnimation } from "framer-motion";

export default function Index() {
  const { webSocket } = useContext(WebSocketContext);
  const classes = useStyles();
  const { data, deviceName, offerCount, showNextOffersPopup, playlistItem } =
    useImko();
  const [offers, setOffers] = useState<IOffer[]>([]);
  const [nextOffers, setNextOffers] = useState<IOffer[]>([]);
  const baseAnim = useAnimation();

  const playNextPlaylistItemMessage = useCallback(() => {
    webSocket.send(
      JSON.stringify({
        type: "PlayNextPlaylistItemMessage",
      })
    );
  }, [webSocket]);

  const getOfferList = useCallback(async () => {
    if (data?.deviceConfiguration) {
      try {
        const apiResult = await getOffers({
          serverId: deviceName,
          offerCount: offerCount,
          playlistItem: playlistItem,
          deviceConfiguration: data.deviceConfiguration,
        });
        if (
          apiResult.data?.success &&
          apiResult.data?.result?.offers?.length > 0
        ) {
          setOffers(apiResult.data?.result.offers);
          setNextOffers(apiResult.data?.result.nextOffers);
        } else {
          playNextPlaylistItemMessage();
        }
      } catch (error) {
        console.log(error);
        playNextPlaylistItemMessage();
      }
    }
  }, [
    deviceName,
    offerCount,
    playlistItem,
    data?.deviceConfiguration,
    playNextPlaylistItemMessage,
  ]);

  const nextInterval = useMemo(() => {
    let result = 30000;
    if (offers.length) {
      const maxNumberOfPhotos = linq.from(offers).max((o) => o.photos?.length);
      const count =
        maxNumberOfPhotos >= MIN_SWIPER_CHANGES
          ? maxNumberOfPhotos
          : MIN_SWIPER_CHANGES;
      // +1500ms ensure that the animation ended and it's avoid a graphical glitch
      result = count * (SWIPER_DURATION + SWIPER_DELAY) + 1500;
    }
    return result;
  }, [offers]);

  const animate = useCallback(
    async (reverse: boolean = false) => {
      const baseAnimation = !reverse
        ? {
            opacity: [0, 1],
            transition: { duration: 2 },
          }
        : {
            opacity: 0,
            transition: { duration: 2 },
          };
      await baseAnim.start(baseAnimation);
    },
    [baseAnim]
  );

  const isEmptyOrError = useMemo(() => {
    if (
      !offers?.length ||
      offers?.length === 0 ||
      !deviceName ||
      deviceName === ""
    ) {
      console.log("isEmptyOrError");
      console.log("offers", offers);
      console.log("deviceName", deviceName);
      console.log(
        "window.config.deviceName",
        (window as any)?.config?.deviceName
      );
      return true;
    } else {
      return false;
    }
  }, [offers, deviceName]);

  useEffect(() => {
    (async () => {
      await getOfferList();
    })();
  }, [getOfferList]);

  useEffect(() => {
    if (isEmptyOrError === false) {
      (async function () {
        await animate();
      })();
    }
  }, [animate, isEmptyOrError]);

  useInterval(async () => {
    await animate(true);
    playNextPlaylistItemMessage();
  }, nextInterval);

  const emptyOrError = useMemo(() => {
    return (
      <div className={classes.emptyOrErrorContainer}>
        {/* <img src={logoGray} alt="" /> */}
      </div>
    );
  }, [classes]);

  // const handleNextOfferForTesting = () => {
  //   playNextPlaylistItemMessage();
  // };

  return (
    <motion.div
      animate={baseAnim}
      className={classes.container}
      // onClick={() => handleNextOfferForTesting()}
    >
      {isEmptyOrError === false ? (
        <>
          {offerCount === 1 && <Template1 offers={offers} />}
          {offerCount === 2 && <Template2 offers={offers} />}
          {offerCount === 4 && <Template4 offers={offers} />}
          {offerCount === 6 && <Template6 offers={offers} />}
          {showNextOffersPopup && nextOffers.length > 0 && (
            <NextPopup offers={nextOffers} />
          )}
        </>
      ) : (
        emptyOrError
      )}
    </motion.div>
  );
}

const useStyles = createUseStyles({
  container: {
    height: "100%",
    width: "100%",
  },
  emptyOrErrorContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    "& img": {
      margin: 100,
    },
  },
});
